module.exports = __webpack_public_path__ + "static/img/px6.8d059cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/px6.png
// module id = a43P
// module chunks = 2